// Datas de RDO são armazenadas como "YYYY-MM-DD" (coluna date do Postgres).
// `new Date("YYYY-MM-DD")` interpreta como MEIA-NOITE UTC — ao formatar em
// timezone brasileiro (UTC-3) a data volta um dia (02/07 vira 01/07).
// Estes helpers fazem o parse no fuso local, eliminando o off-by-one.

/** Converte "YYYY-MM-DD" em Date no fuso local (meio-dia, à prova de DST). */
export function parseYmdLocal(ymd: string): Date {
  const [y, m, d] = ymd.split("-").map(Number);
  return new Date(y, (m ?? 1) - 1, d ?? 1, 12, 0, 0);
}

/** Formata "YYYY-MM-DD" como "dd/MM/yyyy" sem passar por Date/timezone. */
export function formatYmd(ymd: string): string {
  const [y, m, d] = ymd.split("-");
  return `${d}/${m}/${y}`;
}
